import { Reveal, SectionHeading } from "./Reveal";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "Frédérique a cette capacité rare à comprendre en une phrase ce que je n'arrivais pas à formuler depuis des mois. Nos échanges ont transformé ma façon de diriger.",
    name: "Laurent M.",
    role: "Dirigeant d'une PME industrielle, 45 salariés",
  },
  {
    quote: "Nous avons travaillé la QVT avec nos équipes de direction. Résultat : un climat apaisé, des managers plus confiants, et des décisions enfin prises sereinement.",
    name: "Claire D.",
    role: "Directrice générale, secteur services",
  },
  {
    quote: "Un accompagnement d'une grande finesse. Frédérique comprend le haut potentiel de l'intérieur — cela change tout quand on se sent enfin compris sans avoir à s'expliquer.",
    name: "Thomas R.",
    role: "Cadre en reconversion, profil HPI",
  },
];

export default function Testimonials() {
  return (
    <section id="temoignages" data-testid="testimonials-section" className="relative py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeading
          overtitle="Ils en parlent"
          title="Ce que l'accompagnement a changé pour eux."
          align="center"
        />
        <div className="mt-16 grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="group h-full flex flex-col rounded-2xl border border-[#D4AF37]/15 bg-[#111C33]/60 p-8 transition-all duration-500 hover:border-[#D4AF37]/45 hover:bg-[#111C33] hover:-translate-y-1"
              >
                <Quote size={24} className="text-[#D4AF37]/70" />
                <blockquote className="mt-5 flex-1 font-serif-display text-lg italic text-slate-200 leading-relaxed">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-6 border-t border-[#D4AF37]/15 pt-5">
                  <p className="text-sm font-semibold text-white">{t.name}</p>
                  <p className="mt-1 text-xs text-slate-400">{t.role}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
